import React from 'react';
import { useTheme } from '@emotion/react';
import { useSpringCarousel } from '../../hooks';
import { NavigationThumb } from '../thumbs';
import CircleThumb from '../thumbs/CircleThumb';
import { ThumbsContainer } from '../thumbs/styled-components';
import { SliderWrapper, SlidesContainer } from './styled-components';
import { isSmallSlider } from './utils';
const Slider = ({ withLoop, items, onSlideChange, onSetup, bottomThumbs = false, darkThumbs = false, className }) => {
    const theme = useTheme();
    const springConfig = theme.animations.spring;
    const ThumbComponent = isSmallSlider(theme) ? CircleThumb : NavigationThumb;
    const mappedItems = items.map((item) => ({
        id: item.id,
        renderItem: item.Banner,
        renderThumb: (React.createElement(ThumbComponent, { id: `thumb-${item.id}`, itemId: item.id, onClick: () => slideToItem(item.id), darkThumbs: darkThumbs }, item.label)),
        termsAndConditions: item.termsAndConditions,
    }));
    const { carouselFragment, thumbsFragment, slideToItem, isDragging, } = useSpringCarousel({
        springConfig,
        withThumbs: true,
        withLoop,
        items: mappedItems,
        onSetup,
        onSlideChange,
    });
    return (React.createElement(SliderWrapper, { className: className },
        React.createElement(SlidesContainer, { isDragging: isDragging }, carouselFragment),
        items.length > 1 && (React.createElement(ThumbsContainer, { bottomThumbs: bottomThumbs, role: "tablist" }, thumbsFragment))));
};
export default Slider;
